<!--
 * @Descripttion: 上传视频
 * @Author: juanjuanhui
 * @Date: 2021-07-08 22:23:11
 * @LastEditors: quwandong
 * @LastEditTime: 2022-09-07 17:13:11
-->
<template>
  <div>
    <div
      class="demo-image__preview"
      v-if="previewList && previewList.length > 0"
    >
      <div v-for="(val, i) in previewList" :key="i">
        <el-image
          v-if="i < 3"
          style="width: 82px; height: 82px"
          :src="val ? val.pictureUrl : require('@/assets/upimg_failure.png')"
          :preview-src-list="getPreviewImgList(previewList)"
        >
        </el-image>
        <div
          class="img-mask"
          v-if="previewList.length > 3 && i == 2"
          @click="handlePreviewImg(previewList)"
        >
          查看更多
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ImagePreview",
  props: {
    previewList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {};
  },
  computed: {},
  methods: {
    getPreviewImgList(data) {
      return data.map((image) => image.pictureUrl);
    },
    /**
     * @descripttion: 预览图片
     * @Author: juanjuanhui
     * @Date: 2021-12-16 18:55:09
     */
    handlePreviewImg(data) {
      this.$emit("handlePreviewImg", data);
    },
  },
};
</script>

<style lang="scss" scoped>
.demo-image__preview {
  display: flex;
  margin-top: 5px;
  & > div {
    position: relative;
    margin-right: 9px;
    .img-mask {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
    }
    .el-image {
      &:last-child {
        margin-right: 0;
      }
    }
  }
}
</style>
